<template>
  <div ref="root" class="bg-surface-brand-hi rounded-lg p-32 text-center">
    <WarrantyTag class="mb-32" />

    <div class="body-2-bold">{{ i18n(translations.subtitle) }}</div>
    <h2 class="punchline mt-12">{{ i18n(translations.title) }}</h2>
    <div class="body-2 mt-32">{{ i18n(translations.disclaimer) }}</div>
    <div class="mt-32 flex flex-col items-center gap-8">
      <div class="flex w-full flex-col gap-8 md:flex-row">
        <Card
          class="w-full md:w-1/2"
          :subtitle="i18n(translations.step1Subtitle)"
          :tag-label="i18n(translations.step1TagLabel)"
          :title="i18n(translations.step1Title)"
        />
        <Card
          class="w-full md:w-1/2"
          :subtitle="i18n(translations.step2Subtitle)"
          :tag-label="i18n(translations.step2TagLabel)"
          :title="i18n(translations.step2Title)"
        />
      </div>
      <div class="flex w-full flex-col gap-8 md:flex-row">
        <Card
          class="w-full md:w-1/2"
          :subtitle="i18n(translations.step3Subtitle)"
          :tag-label="i18n(translations.step3TagLabel)"
          :title="i18n(translations.step3Title)"
        />

        <Card
          class="w-full md:w-1/2"
          :subtitle="i18n(translations.step4Subtitle)"
          :tag-label="i18n(translations.step4TagLabel)"
          :title="i18n(translations.step4Title)"
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { onUnmounted, ref } from 'vue'

import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { useTracking } from '@backmarket/nuxt-module-tracking/useTracking'
import { useIntersectionObserver } from '@vueuse/core'

import WarrantyTag from '../WarrantyTag/WarrantyTag.vue'

import translations from './ReassuranceInsuranceReturn.translations'
import Card from './components/Card/Card.vue'

const i18n = useI18n()

const { trackProductBlockImpression } = useTracking()
const root = ref<HTMLElement | null>()
const { stop } = useIntersectionObserver(root, ([{ isIntersecting }]) => {
  if (isIntersecting) {
    trackProductBlockImpression({
      block_name: 'reassurance_returns_block',
    })
  }
})
onUnmounted(() => {
  stop()
})
</script>
